import { Company } from 'features/companies';
import { ConnectMaxInfoButton } from 'features/connect-max';
import { paths } from 'features/routing';
import { RoutingTabs } from 'features/ui';
import useUser from 'hooks/useUser';
import { useEffect, useMemo } from 'react';
import { useMatch } from 'react-router-dom';
import { capitalizeFirstChar } from 'utils/string';

type CompanyDetailsNavbarProps = {
  companyId: string;
  company: Company;
  companyName: string;
};

const CompanyDetailsNavbar = ({
  companyId,
  company,
  companyName,
}: CompanyDetailsNavbarProps) => {
  const { hasRole } = useUser();
  const routeMatch = useMatch(`/companies/${companyId}/:tab`);

  const currentTab = useMemo(() => {
    return routeMatch?.params.tab ?? 'details';
  }, [routeMatch]);

  useEffect(() => {
    const titlePrefix = `${companyName} - `;
    const tabName = capitalizeFirstChar(String(routeMatch?.params.tab));
    document.title = titlePrefix + (tabName ?? 'details');
  }, [routeMatch, companyName]);

  return (
    <RoutingTabs
      tabs={[
        {
          label: 'Details',
          to: paths.companyOverview(companyId),
        },
        {
          label: 'Integrations',
          to: paths.companyIntegrations(companyId),
        },
        {
          label: 'Connect Max',
          to: paths.companyConnectMax(companyId),
          show:
            hasRole('Manage Company CI Config') && company.companyTypeId === 2, // Retailer Type
        },
        {
          label: 'Licenses',
          to: paths.companyLicenses(companyId),
        },
        {
          label: 'Users',
          to: paths.companyUsers(companyId),
        },
      ]}
      value={currentTab}
    >
      {currentTab === 'connect-max' && <ConnectMaxInfoButton />}
    </RoutingTabs>
  );
};

export default CompanyDetailsNavbar;
